import Vue from 'vue';
import { configureCompat } from 'vue'

import VueMasonry from 'vue-masonry-css';
import MasonryWall from '@yeger/vue-masonry-wall'
import VueLazyload from 'vue-lazyload'

import VueGoogleMaps from '@fawmi/vue-google-maps'

import LazyLoadDirective from './directives/LazyLoadDirective';
import TableCleanupDirective from './directives/TableCleanupDirective';

import VueAnimate from 'vue-animate-scroll';
import VueScrollTo from 'vue-scrollto';

import Notifications from '@kyvg/vue3-notification'

import VueCookies from 'vue-cookies';

import bus from './utilities/eventbus';

import './views';
import './components';
import './transitions';

configureCompat({
  GLOBAL_MOUNT: true
});

const canonicals = document.querySelectorAll("link[rel='canonical']");
if (canonicals.length) {
    canonicals.forEach((canonical, index) => {
        !index && canonical.setAttribute("href", canonical.getAttribute("href").replace(/\/+$/, '') + '/');
        index && canonical.remove();
    });
}



Vue.use(VueMasonry);
Vue.use(MasonryWall);
Vue.use(VueCookies);
Vue.use(VueLazyload)
Vue.$cookies.config('7d', '/', '', '', '');


const NotificationCookie = {
    install(Vue) {
        Vue.prototype.appendtoNotification = (data) => {
            let notificationItemsString = Vue.$cookies.get('notificationItems');
            if (!notificationItemsString) notificationItemsString = '[]';
            let notificationItemsArr = typeof notificationItemsString === 'string' ? JSON.parse(notificationItemsString) : notificationItemsString;

            notificationItemsArr.push(data);
            notificationItemsString = JSON.stringify(notificationItemsArr.reverse().slice(0, 5).reverse());

            Vue.$cookies.set('notificationItems', notificationItemsString);
            bus.$emit('notifAdded');
        }
    },
}
Vue.use(NotificationCookie);

const NotificationMoodboard = {
    install(Vue) {
        Vue.prototype.toggleNotificationMoodboard = () => {
            bus.$emit('moodboardAdded');
        }
    },
}
Vue.use(NotificationMoodboard);


const linkNavigateOverlay = {
    install(Vue) {
        Vue.prototype.linkOverlayShow = (data) => {
            bus.$emit('pageTransitionFadein');
            Vue.$cookies.set('overlayShow', 'yes');
            Vue.$cookies.set('overlayShowDirection', 'forward');

            // get current url to go back later
            Vue.$cookies.set('previousPage', window.location.href); 
            
            setTimeout(() => {
                window.location.href = data;
            }, 500);
        },

        Vue.prototype.linkOverlayNavigateBack = () => {
            bus.$emit('pageTransitionFadeinBack');
            Vue.$cookies.set('overlayShow', 'yes');
            Vue.$cookies.set('overlayShowDirection', 'back');
            const previousURL = Vue.$cookies.get('previousPage');

            setTimeout(() => {
                const referrer = document.referrer;
                const host = window.location.hostname;
                console.log(referrer, host);
                
                if (referrer.indexOf(host) > -1) {
                    if(previousURL) {
                        Vue.$cookies.set('previousPage', '');
                        window.location.href = previousURL;
                    } else {
                        window.history.go(-1);
                    }
                } else {
                    window.location.href = window.location.origin;
                }
            }, 500);
        },

        Vue.prototype.linkOverlayHide = () => {
            setTimeout(() => {
                bus.$emit('pageTransitionFadeOut');
            }, 100);
            Vue.$cookies.set('overlayShow', '');
            Vue.$cookies.set('overlayShowDirection', '');
        },

        Vue.prototype.linkOverlayHideBack = () => {
            setTimeout(() => {
                bus.$emit('pageTransitionFadeoutBack');
            }, 100);
            Vue.$cookies.set('overlayShow', '');
            Vue.$cookies.set('overlayShowDirection', '');
        }
    },
}
Vue.use(linkNavigateOverlay);

const filterbyTagsAndCategories = {
    install(Vue) {
        Vue.prototype.filterbyTagsAndCategories = (dataset, selectedFilter) => {
            const filterKeys = { category: 'categories', tag: 'tags' };
            let filteredList = dataset;
            
            if (typeof filteredList.forEach !== 'function') {
                let arr = [];
                const obj = filteredList;
                Object.keys(obj).forEach((key) => {
                    arr.push(obj[key]);
                });
                filteredList = arr;
            }

            Object.keys(filterKeys).forEach((itemkey) => {
                if (selectedFilter[itemkey].length > 0) {
                    let filterBy = selectedFilter[itemkey];

                    filteredList = filteredList.filter((item) => {
                        let itemKeys = item[filterKeys[itemkey]];
                        if (itemKeys) {
                            itemKeys = JSON.parse(JSON.stringify(itemKeys));
                            let mapped = Object.keys(itemKeys).map((field) => {
                                return field;
                            });

                            let found = false;
                            filterBy.forEach((singleKey) => {
                                if (mapped.includes(singleKey)) found = true;
                            });

                            return found;
                        }
                    });
                }
            });
            // console.log('filteredList ::: ', filteredList);
            return filteredList;
        },
        Vue.prototype.getFilteredCatAndTagList = (items, cats, tags) => {
            let existed = {
                cats: [],
                tags: []
            };
            let filtered = {
                categories: [],
                tags: []
            };

            if (typeof items.forEach !== 'function') {
                let arr = [];
                const obj = items;
                Object.keys(obj).forEach((key) => {
                    arr.push(obj[key]);
                });
                items = arr;
            }
            if (typeof cats.forEach !== 'function') {
                let arr = [];
                const obj = cats;
                Object.keys(obj).forEach((key) => {
                    arr.push(obj[key]);
                });
                cats = arr;
            }
            if (typeof tags.forEach !== 'function') {
                let arr = [];
                const obj = tags;
                Object.keys(obj).forEach((key) => {
                    arr.push(obj[key]);
                });
                tags = arr;
            }


            items.forEach((item, index) => {
                if (item.title) {
                    Object.keys(item.categories).forEach((key) => {
                        existed.cats.push(item.categories[key]);
                    });
                    Object.keys(item.tags).forEach((key) => {
                        existed.tags.push(item.tags[key]);
                    });
                }
            });

            existed.cats = Array.from(new Set(existed.cats));
            existed.tags = Array.from(new Set(existed.tags));

            cats.forEach((cat, idx) => {
                if (existed.cats.indexOf(cat.urlsegment) >= 0) {
                    filtered.categories.push(cat);
                }
            });

            tags.forEach((tag, idx) => {
                if (existed.tags.indexOf(tag.urlsegment) >= 0) {
                    filtered.tags.push(tag);
                }
            });

            return filtered;
        },
        Vue.prototype.convertItemsObjToArray = (obj) => {
            if(!obj) {
                return [];
            }

            if (typeof obj.forEach === 'function') {
                let cleanArray = [];
                obj.forEach((item) => {
                    if(JSON.stringify(item) !== '[]'){
                        let tmp = item;
                        if(typeof tmp.summary !== 'undefined' && tmp.summary===null){
                            tmp.summary = '';
                        }
                        cleanArray.push(tmp);
                    };
                });
                return JSON.parse(JSON.stringify(cleanArray));
            }

            let arr = [];
            Object.keys(obj).forEach((key) => {
                arr.push(obj[key]);
            });
            return arr;
        },
        Vue.prototype.slugifyString = (string) => {
            if(typeof string !== 'string') return false;

            const title = string.toLowerCase().split(' ').map(function(word) {
                return (word.charAt(0).toUpperCase() + word.slice(1));
            }).join(' ');

            const slug = title
                .toString()
                .toLowerCase()
                .trim()
                .replace(/\s+/g, "-")
                .replace(/[^\w\-]+/g, "-")
                .replace(/\-\-+/g, "-")
                .replace(/^-+/, "-")
                .replace(/-+$/, "-")
                .replace(/\-+/g, "-");

            return slug;
        },
        Vue.prototype.restructureFilterArray = (array, type) => {
            let filterArray = [];
            array.forEach((item, index) => {
                let slug = Vue.prototype.slugifyString(item.title);
                filterArray.push({
                    id: item.id,
                    title: item.title,
                    urlsegment : slug,
                    filterid: `${type}-${slug}`
                });
            });

            return filterArray;
        }
    }
}
Vue.use(filterbyTagsAndCategories);


const simpleTooltipHover = {
    install(Vue) {
        Vue.prototype.tooltipinfoHoverIn = (ev, text) => {
            //console.log(ev.target)

            let tooltip = document.createElement("SPAN");
            let t = document.createTextNode(text);
            tooltip.appendChild(t);
            tooltip.classList.add("tooltipinfo");
            ev.target.appendChild(tooltip);
        },
            Vue.prototype.tooltipinfoHoverOut = (ev) => {
                // console.log(ev.target)
                ev.target.querySelectorAll("span.tooltipinfo").forEach(e => e.remove());
            }
    }
}
Vue.use(simpleTooltipHover);


const simpleRandomizedString = {
    install(Vue) {
        Vue.prototype.getRandomizedString = () => {
            let length = 12;
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() *
                    charactersLength));
            }
            return result;
        }
    }
}
Vue.use(simpleRandomizedString);

const simpleCookies = {
    install(Vue) {
        Vue.prototype.simpleCookieGet = (cname) => {
            let name = cname + "=";
            let ca = document.cookie.split(';');
            for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
    }
}
Vue.use(simpleCookies);


Vue.directive('lazyload', LazyLoadDirective);
Vue.directive('tablecleanup', TableCleanupDirective);

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyC-4MtwDLwaO6kaF1tSn5HWCmSUP4Dj5SQ',
        libraries: 'places',
    },
    installComponents: true
});

Vue.use(VueAnimate);
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

Vue.use(Notifications)

import addressfinder from './utilities/addressfinder';
addressfinder.initialise();

const app = new Vue({
    el: '#app'
});

export default app;

function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

function setGlobalCssvars() {
    const html = document.documentElement;
    const ds = html.style;
    const winSizes = {
        inner_w: html.clientWidth,
        inner_h: html.clientHeight
    }

    ds.setProperty('--vw-100', winSizes.inner_w + 'px');

    const body = document.body;

    if(isTouchDevice()) {
        body.classList.add("is--touch");
        body.classList.remove("no--touch");
    } else {
        body.classList.remove("is--touch");
        body.classList.add("no--touch");
    }

    const homepageBanner = document.querySelectorAll('.banner--home');
    if(homepageBanner.length>0){
        homepageBanner.forEach((elem, index) => {
            const secondary = elem.querySelector('.banner-secondary');
            
            elem.style.setProperty('--secondary-height',`${secondary.offsetHeight}px`);
            elem.classList.add('calculated');

            const colContent = elem.querySelector('.col-content--primary');
            const ccComputed = getComputedStyle(colContent);
            const bannerContent = elem.querySelector('.banner-content');

            const hh = {
                x: colContent.offsetHeight - (parseFloat(ccComputed.paddingTop) + parseFloat(ccComputed.paddingBottom)),
                a: window.innerHeight - (parseFloat(ccComputed.paddingTop) + parseFloat(ccComputed.paddingBottom) + parseFloat(secondary.offsetHeight)) ,
                b: bannerContent.offsetHeight
            }
            if(hh.a<hh.b) {
                elem.classList.add('narrow-height');
            } else {
                elem.classList.remove('narrow-height');
            }
        });
    }
}
let glogalCssVarsID = 0;
function timeoutGlobalCssvars() {
    clearTimeout(glogalCssVarsID);
    glogalCssVarsID = setTimeout(() => {
        setGlobalCssvars();
    }, 250);
}
window.addEventListener("resize", timeoutGlobalCssvars);
setGlobalCssvars();


function setBrowserClass() {
    const ua = window.navigator.userAgent;
    const webkit = !!ua.match(/WebKit/i);
    const windows = !!ua.match(/Windows/i);

    if (webkit && windows) {
        // browser--webkit-window
        const body = document.body;
        body.classList.add("browser--webkit-windows");
    }
}
setBrowserClass();

window.onpageshow = function (event) {
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

    if (event.persisted && iOSSafari) {
        window.location.reload();
    }
};

const ifr = document.querySelectorAll('*[id^="JotFormIFrame"]');
if (ifr.length) {
    document.getElementById('app').style.backgroundColor = '#F8F8F8';
}
window.handleIFrameMessage = function (e) {
    if (typeof e.data === 'object') { return; }
    if (ifr.length) {
        const args = e.data.split(":");
        const id = args[args.length - 1];
        const iframe = document.getElementById("JotFormIFrame-" + id);
        if (args[0] === 'setHeight') {
            const height = parseInt(args[1]) + 20;
            iframe.style.height = height + "px";
        }
    }
};
if (window.addEventListener) {
    window.addEventListener("message", handleIFrameMessage, false);
}
else if (window.attachEvent) {
    window.attachEvent("onmessage", handleIFrameMessage);
}



// ======================
// DEVELOPMENT ONLY CHECKING SCREEN SIZE
// ======================

// let el = document.createElement("output");
// document.body.append(el);
// Object.assign(el.style, {
//     position: "fixed",
//     bottom: 0,
//     left: 0,
//     background: "red",
//     color: "white",
//     padding: "10px",
//     fontSize: "14px",
//     opacity: 0.9,
//     zIndex: 99999999
// });
// function updateOutput() {
//     let html = document.documentElement;
//     el.value = html.clientWidth + " × " + html.clientHeight;
// }
// window.addEventListener("resize", updateOutput);
// updateOutput();